import React, { useRef } from 'react'
import {
  Box,
  Text,
  IcoMoon,
  CancelIcon,
  PlusIcon,
  AddIconWMO,
} from '@usap/uicomponents'
import { Heading5 } from '../../../../common/heading'

const DiagnosisWMO = ({
  onChange,
  removeDocument,
  formFile = {},
  errorSteps = {},
  widget,
  selectedPart,
  isDesktop,
  organizedWidgets,
  maxFiles,
  fileInputId
}) => {
  const {
    id,
    required,
    title = 'Upload Diagnostic Document',
    subtitle = "It's highly recommended to provide a diagnostic test results of your Catalytic Converter from your mechanic. This can help us expedite the return process.",
  } = widget

  const fileInputs = useRef({})
  const requiredData = required
    ? ''
    : '<span style="font-size: 16px; font-weight: 400; color: #5C5C5C;">(Optional)</span>'

  return (
    <Box
      margin={{ bottom: '24px' }}
      key={id}
    >
      <Heading5
        title={`${title} ${requiredData}`}
        width="large"
        size="medium"
        color="dark-2"
        style={{ fontSize: isDesktop ? '16px' : '14px', fontWeight: 600, maxWidth: '100%' }}
        margin={{ bottom: '8px', top: '0px' }}
      />
      <Text id={`error-${id}`} style={{ color: '#f90000', fontSize: '12px' }}>
        {errorSteps[`${id}`]}
      </Text>
      <Text size='14px' margin={{ bottom: "8px" }} style={{ lineHeight: "165%" }}>
        {subtitle}
      </Text>

      { organizedWidgets.map(prop => (
        <>
          { formFile[prop.id] && (
            <Box
              key={`${id}-${prop.id}`}
              width="100%"
              style={{
                background: '#f5f5f5',
                textAlign: 'center',
                padding: '8px',
                position: 'relative',
                borderRadius: '6px',
                marginBottom: '8px',
              }}
            >
              <Text 
                color="dark-2"
                style={{
                  userSelect: 'none',
                  padding: '0px 8px',
                  textAlign: 'left',
                  fontSize: "14px"
               }}
              >
                {formFile[`${prop.id}`].content.name || ''}
              </Text>
              <IcoMoon
                icon={CancelIcon}
                color="dark-2"
                size="small"
                style={{
                  position: 'absolute',
                  float: 'right',
                  right: '4px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  removeDocument(prop.id, widget, selectedPart)
                }}
              />
            </Box>
          )}
          { !formFile[prop.id] && (
            <input
              accept=".jpg, .jpeg, .gif, .png, .bmp, .docx, .doc, .pdf"
              ref={ref => { fileInputs.current[`${prop.id}`] = ref }}
              name={selectedPart}
              widgetreq={required ? 'true' : ''}
              id={prop.id}
              type="file"
              onChange={onChange}
              style={{ visibility: 'hidden', width: '1px', height: '1px' }}
            />
          )}
        </>
      ))}
      { !maxFiles && (
        <Box
          width="100%"
          style={{
            background: '#f4f4f4',
            fontSize: '14px',
            flexDirection: "row",
            alignItems: 'center',
            justifyContent: 'center',
            padding: '16px',
            cursor: 'pointer',
            margin: '0px',
            borderRadius: '4px',
            gap: "6px"
          }}
          onClick={() => {
            fileInputs.current[`${fileInputId}`].click()
          }}
        >
          <AddIconWMO width='24px' height='24px' />
          <Text size="14px" color="dark-2" style={{ fontWeight: "600" }}>
            Add File
          </Text>
        </Box>
      )}
    </Box>
  )
}

export default DiagnosisWMO
